import { environment } from '../environments/environment';
import { MsalClient } from '@app/security/msal-client';

export const formatGetHeaders = async () => {
  const accessToken = await retrieveToken();
  return ({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// eslint-disable-next-line
export const formatPutHeaders = async (body?: any) => {
  const accessToken = await retrieveToken();
  return ({
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
};

export const formatDeleteHeaders = async () => {
  const accessToken = await retrieveToken();
  return ({
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

// eslint-disable-next-line
export const formatPostHeaders = async (body: any) => {
  const accessToken = await retrieveToken();
  return ({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });
};

export const formatMultipartHeaders = async (body: FormData) => {
  const accessToken = await retrieveToken();
  return ({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body,
  });
};

export const retrieveToken = async () => {
  const msalClient = MsalClient.getInstance();
  const activeAccount = msalClient.getActiveAccount();
  if (activeAccount) {
    let token;
    try {
      token = await msalClient.acquireTokenSilent({
        scopes: [...environment.authentication.scopes],
        account: activeAccount
      });
    } catch (error) {
      console.error('Error acquiring token:', error);
      return Promise.reject();
    }
    return token.accessToken;
  } else {
    console.log('No active account, please login');
    return Promise.reject();
  }
};
